import { practice } from 'modules/schema';
import { normalize } from 'normalizr';

import {
  Entities,
  PracticesState,
  PhysiciansState,
  AppointmentTypesState,
  PracticeSuccessResponse,
  SchedulesState,
} from 'types';
import { QueryConfig } from 'redux-query';

export const getPracticeQuery = (practiceId: number): QueryConfig => ({
  queryKey: `getPractice:${practiceId}`,
  transform: ({ data }: PracticeSuccessResponse): Entities => normalize(data, practice).entities,
  update: {
    appointmentTypes: (
      prevAppointmentTypes: AppointmentTypesState,
      newAppointmentTypes: AppointmentTypesState,
    ): AppointmentTypesState => ({
      ...prevAppointmentTypes,
      ...newAppointmentTypes,
    }),
    physicians: (
      prevPhysicians: PhysiciansState,
      newPhysicians: PhysiciansState,
    ): PhysiciansState => ({
      ...prevPhysicians,
      ...newPhysicians,
    }),
    practices: (prevPractices: PracticesState, newPractices: PracticesState) =>
      prevPractices
        ? {
            ...prevPractices,
            [practiceId]: {
              ...prevPractices[practiceId],
              ...newPractices[practiceId],
            },
          }
        : newPractices,
    schedules: (prevSchedules: SchedulesState, newSchedules: SchedulesState): SchedulesState => ({
      ...prevSchedules,
      ...newSchedules,
    }),
  },
  url: `book/api/practices/${practiceId}`,
});
